import routeDefinitions from '../routes';
import { createRouteConfig } from 'utils/route_config';

const routeConfig = createRouteConfig(routeDefinitions);

export default routeConfig;
